import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/footers/MuseFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/headers/MuseHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/MuseWrapper.tsx");
